/**
 * Bisou Rivage — Notre Histoire — Scroll animations + Artist sphere
 */
(function () {
  'use strict';

  function initAnimations() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els = document.querySelectorAll('.bnh-anim');
    if (!els.length) return;
    if (reduced) { els.forEach(function (el) { el.classList.add('bnh-visible'); }); return; }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('bnh-visible'); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0.1 });
    els.forEach(function (el) { observer.observe(el); });
  }

  function initSphere() {
    var sphere = document.querySelector('.bnh-sphere');
    if (!sphere) return;
    var items = sphere.querySelectorAll('.bnh-sphere-item');
    if (!items.length) return;
    var radius = Math.min(sphere.offsetWidth, sphere.offsetHeight) * 0.36;
    items.forEach(function (item, i) {
      var phi = Math.acos(1 - (2 * (i + 0.5)) / items.length);
      var theta = Math.PI * (1 + Math.sqrt(5)) * i;
      item.dataset.x = (radius * Math.sin(phi) * Math.cos(theta)).toFixed(1);
      item.dataset.y = (radius * Math.sin(phi) * Math.sin(theta)).toFixed(1);
      item.dataset.z = (radius * Math.cos(phi)).toFixed(1);
    });
    var aX = 0, aY = 0, drag = false, mX = 0, mY = 0;
    function rotate() {
      if (!drag) { aX += 0.002; aY += 0.004; }
      items.forEach(function (item) {
        var ox = +item.dataset.x, oy = +item.dataset.y, oz = +item.dataset.z;
        var x = ox * Math.cos(aY) - oz * Math.sin(aY), z = ox * Math.sin(aY) + oz * Math.cos(aY);
        var y = oy * Math.cos(aX) - z * Math.sin(aX); z = oy * Math.sin(aX) + z * Math.cos(aX);
        var s = (z + radius * 2) / (radius * 3);
        item.style.transform = 'translate3d(' + x.toFixed(0) + 'px,' + y.toFixed(0) + 'px,0) scale(' + s.toFixed(3) + ')';
        item.style.opacity = Math.max(0.2, Math.min(1, s)).toFixed(2);
        item.style.zIndex = Math.floor(z + radius);
      });
      requestAnimationFrame(rotate);
    }
    sphere.addEventListener('mousedown', function (e) { drag = true; mX = e.clientX; mY = e.clientY; });
    document.addEventListener('mousemove', function (e) { if (!drag) return; aY += (e.clientX - mX) * 0.005; aX += (e.clientY - mY) * 0.005; mX = e.clientX; mY = e.clientY; });
    document.addEventListener('mouseup', function () { drag = false; });
    sphere.addEventListener('touchstart', function (e) { drag = true; mX = e.touches[0].clientX; mY = e.touches[0].clientY; }, { passive: true });
    document.addEventListener('touchmove', function (e) { if (!drag) return; aY += (e.touches[0].clientX - mX) * 0.005; aX += (e.touches[0].clientY - mY) * 0.005; mX = e.touches[0].clientX; mY = e.touches[0].clientY; }, { passive: true });
    document.addEventListener('touchend', function () { drag = false; });
    requestAnimationFrame(rotate);
  }

  function init() { initAnimations(); initSphere(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
  }
})();
